export default function Step1Welcome({ userName }) {
  return (
    <div className="text-center">
      <p className="text-sm mb-3" style={{ color: "#2D2A24" }} data-testid="f3-welcome-text">
        Hola <strong>{userName || "usuario"}</strong>, vamos a evaluar tu nivel de actividad física.
      </p>

      <div
        className="rounded-[14px] p-4 mt-4 text-xs leading-relaxed text-left"
        style={{ background: "#FCFAEE", border: "1px solid #E2D9CB", color: "#2D2A24" }}
        data-testid="f3-intro-text"
      >
        <p className="mb-2">
          Las siguientes preguntas se refieren a tu actividad física durante los{" "}
          <strong>últimos 7 días</strong>. Piensa en las actividades que haces en el trabajo,
          en casa, para trasladarte y en tu tiempo libre.
        </p>
        <p>
          Solo cuenta las actividades que duran al menos <strong>10 minutos seguidos</strong>.
        </p>
      </div>
    </div>
  );
}
